<ng-template message-host></ng-template>
